

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.SizeFinder = factory());
}(this, function () {
    'use strict';

    const TYPE_MAP = {
        top: ['W_T-shirts', 'W_Camis', 'W_Outerwear', 'W_T-shirts', 'W_T-shirts', 'W_Shirts', 'W_Shirts', 'W_T-shirts', 'W_Shirts', 'W_T-shirts', 'W_T-shirts', 'W_Outerwear', 'W_A-Line Dresses', 'W_Straight Dresses', 'W_Balloon Dresses', 'W_Polo', 'W_Skinny-Fit Dresses', 'W_T-shirt', 'W_T-shirts', 'W_V-Neck', 'W_Skater Dresses', 'W_Overalls & Jumpsuits', 'W_Tank Tops', 'W_Shirt', 'W_Coats', 'W_Denim', 'W_Dresses', 'W_Camis', 'W_Camis & Cami Tops', 'W_Ponchos', 'W_Trench Coats', 'W_Jackets', 'W_Shirts', 'W_Dress', 'W_Vests', 'W_Polo Shirts', 'W_Knitwear', 'W_Knitted T-Shirts', 'W_Sweater Vests', 'W_Knitted T-Shirts', 'W_Knitted Dresses', 'W_Knitted Vests', 'W_Knitted Cardigans', 'W_Knitted Cardigans', 'W_Padded Coats', 'W_Bandeau', 'W_Denim Shirts', 'W_Denim Dresses', 'W_Denim Vests', 'W_Denim Jackets', 'W_Fur Coats', 'W_Leather Jackets', 'W_Outerwear', 'W_Sweatshirts', 'W_Blazers', 'W_Denim T-Shirts', 'W_Denim Pinafore Dresses', 'W_Denim Shirts', 'W_Denim Dresses', 'W_Denim Vests', 'W_Denim Jackets', 'W_Chiffon', 'W_Down Outerwear', 'W_Down Outerwear', 'W_Crew Neck', 'W_Blouses', 'W_V-Neck T-shirts', 'W_Henley Shirts', 'W_Asymmetric Midi Dresses', 'W_Tea Dresses', 'W_Shirts Dresses', 'W_Draped Dresses', 'W_Hoodie T-shirts', 'W_Denim Shirts', 'W_Denim Dresses', 'W_Denim Jackets', 'W_T-shirts with Shoulder Pads', 'W_Cami Tops', 'W_Cami Dresses', 'W_Cropped Coats', 'W_Cropped Jackets', 'W_Cropped Blazers', 'W_Glossy Blouses', 'W_Polo T-shirts', 'W_Square-cut Collar T-shirts', 'W_Duster', 'W_Roll Neck', 'W_Turtle Neck T-shirts', 'W_Worker Blouson', 'W_Wrapped Dressess', 'W_Tailored Vest', 'W_Biker Jackets', 'W_Padded', 'W_Skinny-Fit Dresses', 'W_Trucker Jackets', 'W_Slit Dresses', 'W_Shirts', 'W_Shirts', 'W_Culottes', 'W_Wide Straps', 'W_Loose Dresses', 'W_Safari Jackets', 'W_Halterneck Tops', 'W_Cami Dresses', 'W_Knitted Thin Cardi', 'W_Knitted Ponchos', 'W_Knitted Thick Cardi', 'W_Knitted Cardigans', 'W_Knitted Pants', 'W_Poncho Knitwear', 'W_Hoodie T-shirts', 'W_Wadded Jacket', 'W_Puff Dresses', 'W_Furs', 'W_Tops', 'W_Tunic', 'W_Double-Breasted Blazers', 'W_Woven Shirts', 'W_Woven Camis', 'W_Jumpers', 'W_Overshirts', 'W_Blazers', 'W_Camis', 'W_Corsets', 'W_Shirts', 'W_Off-shoulder T-shirts', 'W_Crew Neck T-shirts', 'W_Long Coats', 'W_Frock Coats', 'W_Thobe', 'W_Abaya', 'W_Knitted T-shirts', 'W_Knitted Skirts', 'W_Knitted Vests', 'W_Knitted Ponchos', 'W_Knitted Cardigans', 'W_Knitted Dresses', 'W_Knitted Cardigans', 'W_Tube Dresses', 'W_Midi Coats'
        ],

        bottom: ['W_Skinny-Fit Pants', 'W_Jeans', 'W_Denim Jumpsuits', 'W_A-Line Skirts', 'W_Straight Skirts', 'W_Balloon Skirts', 'W_Skinny-Fit Skirts', 'W_Skirt', 'W_Overalls & Jumpsuits', 'W_Shorts', 'W_Harem Pants', 'W_Skinny-Fit Pants', 'W_Trousers', 'W_Wide-Leg Pants', 'W_Flare Pants', 'W_Jumpsuits', 'W_Carrot Fit Pants', 'W_Knitted Skirts', 'W_Knitted Pants', 'W_Denim T-Shirts', 'W_Denim Skirts', 'W_Denim Overalls', 'W_Denim Pinafore Dresses', 'W_Denim Shorts', 'W_Denim Jumpsuits', 'W_Jeans', 'W_Jogger Pants', 'W_Denim Skirts', 'W_Denim Overalls', 'W_Denim Shorts', 'W_Denim Jumpsuits', 'W_Jeans', 'W_Fishtail Skirts', 'W_Straight Pants', 'W_Bermuda Shorts', 'W_Bermuda Skorts', 'W_Pleated Skirts', 'W_Overalls', 'W_Leggings', 'W_Denim Leggings', 'W_Denim Skirts', 'W_Cycling Shorts', 'W_Thongs', 'W_Denim Shorts', 'W_Dungarees', 'W_Harem Jeans', 'W_Regular Skirts', 'W_Skinny-Fit Jeans', 'W_Bodysuits', 'W_Wide-Leg Jeans', 'W_Flare Jeans', 'W_Playsuits', 'W_Denim Jumpsuits', 'W_Playsuits', 'W_Jumpsuits', 'W_Carrot Fit Jeans', 'W_Denim Leggings', 'W_Denim Cami Dresses', 'W_Denim Dungarees', 'W_Skinny Jeans', 'W_Cropped Jeans', 'W_Jeans', 'W_Wide Leg Jeans', 'W_Flare Jeans', 'W_Denim Playsuits', 'W_Denim Playsuits', 'W_Denim Jumpsuits', 'W_Mom Jeans', 'W_Boyfriend Jeans', 'W_Capri Jeans', 'W_Denim Chino', 'W_Straight Jeans', 'W_Ripped Jeans', 'W_Pencil Skirts', 'W_Pencil Skirts', 'W_Skorts', 'W_Jogger Jeans', 'W_Chino Shorts', 'W_Chino', 'W_Trousers', 'W_Knitted Pants', 'W_Regular Skirts', 'W_Straight Skirts', 'W_Straight Jeans']
    }


    const SIZE_TOP_MAP = {
        '150-155': {
            '38-45': 'XS',
            '45-47': 'S',
            '47-50': 'S',
            '50-52': 'M',
            '52-55': 'M',
            '55-57': 'L',
            '57-60': 'L',
            '60-62': 'XL',
            '62-65': 'XL',
            '65-67': 'XXL',
            '67-70': 'XXL',
            '70-72': 'XXXL',
            '72-80': '/',
            '80-88': '/',
        },
        '155-160': {
            '38-45': 'XS',
            '45-47': 'S',
            '47-50': 'S',
            '50-52': 'M',
            '52-55': 'M',
            '55-57': 'L',
            '57-60': 'L',
            '60-62': 'XL',
            '62-65': 'XL',
            '65-67': 'XXL',
            '67-70': 'XXL',
            '70-72': 'XXXL',
            '72-80': '/',
            '80-88': '/',
        },
        '160-165': {
            '38-45': 'XS',
            '45-47': 'XS',
            '47-50': 'S',
            '50-52': 'S',
            '52-55': 'M',
            '55-57': 'M',
            '57-60': 'L',
            '60-62': 'L',
            '62-65': 'XL',
            '65-67': 'XL',
            '67-70': 'XXL',
            '70-72': 'XXL',
            '72-80': 'XXL',
            '80-88': '/',
        },
        '165-170': {
            '38-45': 'XS',
            '45-47': 'XS',
            '47-50': 'XS',
            '50-52': 'S',
            '52-55': 'S',
            '55-57': 'M',
            '57-60': 'M',
            '60-62': 'L',
            '62-65': 'L',
            '65-67': 'XL',
            '67-70': 'XL',
            '70-72': 'XXL',
            '72-80': 'XXL',
            '80-88': 'XXXL',
        },
        '170-175': {
            '38-45': '/',
            '45-47': 'S',
            '47-50': 'S',
            '50-52': 'S',
            '52-55': 'M',
            '55-57': 'M',
            '57-60': 'M',
            '60-62': 'L',
            '62-65': 'L',
            '65-67': 'L',
            '67-70': 'XL',
            '70-72': 'XL',
            '72-80': 'XXL',
            '80-88': 'XXXL',

        },
        '175-180': {
            '38-45': '/',
            '45-47': '/',
            '47-50': '/',
            '50-52': 'M',
            '52-55': 'M',
            '55-57': 'M',
            '57-60': 'M',
            '60-62': 'M',
            '62-65': 'L',
            '65-67': 'L',
            '67-70': 'XL',
            '70-72': 'XL',
            '72-80': 'XXL',
            '80-88': 'XXXL',
        },
        '180-185': {
            '38-45': '/',
            '45-47': '/',
            '47-50': '/',
            '50-52': '/',
            '52-55': '/',
            '55-57': '/',
            '57-60': '/',
            '60-62': '/',
            '62-65': '/',
            '65-67': 'L',
            '67-70': 'L',
            '70-72': 'L',
            '72-80': 'XL',
            '80-88': 'XXL',
        }
    }

    const SIZE_BOTTOM_MAP = {
        '150-155': {
            '34-40': 'XXS/25',
            '41-42': 'XS/26',
            '43-45': 'XS/26',
            '46-47': 'S/27',
            '48-50': 'S/27',
            '51-52': 'M/28',
            '53-55': 'M/28',
            '56-57': 'L/29',
            '58-60': 'L/29',
            '61-62': 'XL/30',
            '63-65': 'XL/30',
            '66-67': 'XL/30',
            '68-75': 'XXL/31',
            '76-83': 'XXL/31',
            '84-92': '/',
        },
        '155-160': {
            '34-40': 'XXS/25',
            '41-42': 'XS/26',
            '43-45': 'XS/26',
            '46-47': 'S/27',
            '48-50': 'S/27',
            '51-52': 'M/28',
            '53-55': 'M/28',
            '56-57': 'L/29',
            '58-60': 'L/29',
            '61-62': 'XL/30',
            '63-65': 'XL/30',
            '66-67': 'XL/30',
            '68-75': 'XXL/31',
            '76-83': 'XXL/31',
            '84-92': 'XXXL/32',
        },
        '160-165': {
            '34-40': 'XXS/25',
            '41-42': 'XXS/25',
            '43-45': 'XS/26',
            '46-47': 'XS/26',
            '48-50': 'S/27',
            '51-52': 'S/27',
            '53-55': 'M/28',
            '56-57': 'M/28',
            '58-60': 'L/29',
            '61-62': 'L/29',
            '63-65': 'XL/30',
            '66-67': 'XL/30',
            '68-75': 'XL/30',
            '76-83': 'XXL/31',
            '84-92': 'XXXL/32',
        },
        '165-170': {
            '34-40': '/',
            '41-42': 'XXS/25',
            '43-45': 'XXS/25',
            '46-47': 'XS/26',
            '48-50': 'XS/26',
            '51-52': 'S/27',
            '53-55': 'S/27',
            '56-57': 'M/28',
            '58-60': 'M/28',
            '61-62': 'L/29',
            '63-65': 'L/29',
            '66-67': 'XL/30',
            '68-75': 'XL/30',
            '76-83': 'XXXL/32',
            '84-92': 'XXXL/32',
        },
        '170-175': {
            '34-40': '/',
            '41-42': 'XXS/25',
            '43-45': 'XXS/25',
            '46-47': 'XS/26',
            '48-50': 'S/27',
            '51-52': 'S/27',
            '53-55': 'S/27',
            '56-57': 'M/28',
            '58-60': 'M/28',
            '61-62': 'L/29',
            '63-65': 'L/29',
            '66-67': 'XL/30',
            '68-75': 'XL/30',
            '76-83': 'XXXL/32',
            '84-92': 'XXXL/32',
        },
        '175-180': {
            '34-40': '/',
            '41-42': '/',
            '43-45': 'XS/26',
            '46-47': 'XS/26',
            '48-50': 'S/27',
            '51-52': 'S/27',
            '53-55': 'S/27',
            '56-57': 'S/27',
            '58-60': 'M/28',
            '61-62': 'M/28',
            '63-65': 'L/29',
            '66-67': 'L/29',
            '68-76': 'XL/30',
            '76-83': 'XXL/31',
            '84-92': 'XXL/31',
        },
        '180-185': {
            '34-40': '/',
            '41-42': '/',
            '43-45': '/',
            '46-47': '/',
            '48-50': '/',
            '51-52': '/',
            '53-55': '/',
            '56-57': '/',
            '58-60': '/',
            '61-62': 'M/28',
            '63-65': 'M/28',
            '66-67': 'L/29',
            '68-76': 'L/29',
            '76-83': 'XXL/31',
            '84-92': 'XXL/31',
        }
    }

    class SizeFinder {
        constructor(options = {}) {
            this.config = {
                productType: options.productType || '',
                apiUrl: options.apiUrl || '',
                buttonText: options.buttonText || 'Find My Size',
                cookieExpireDays: options.cookieExpireDays || 99999,
                customStyles: options.customStyles || {},
                onComplete: options.onComplete || function () { },
                mTarget: options.mTarget || '',
                pcTarget: options.pcTarget || '',
                ...options
            };

            this.init();
        }

        init() {
            // console.log(this.config.product)
            if (!this.isValidType(this.config.productType)) {
                document.querySelector('.sizeGuide__mo').classList.add('sizeGuide__mo_reset');
                console.error('Invalid product type:', this.config.productType);
                return;
            }

            // const position = this.isTopOrBottom(this.config.productType);

            // 检查是否已有存储的尺码数据
            this.savedSize = this.getCookie('userSize');
            console.log('this.savedSize', this.savedSize);
            // 如果有保存的数据，立即计算推荐尺码
            if (this.savedSize) {
                try {
                    this.recommendedSize = this.calculateRecommendedSize(this.savedSize);
                    this.setDefaultSize();
                    console.log('已找到存储的尺码数据，推荐尺码:', this.recommendedSize);
                } catch (error) {
                    console.error('计算推荐尺码失败:', error);
                    this.recommendedSize = null;
                }
            } else {
                console.log('未找到存储的尺码数据');
                this.recommendedSize = null;
            }
            this.mount(this.config.mTarget);
            this.mount(this.config.pcTarget);
            this.watchCurrentSize()
            // this.initSizeClickListener();
        }

        // 检查是否为有效的商品类型
        isValidType(type) {
            return TYPE_MAP['top'].includes(type) || TYPE_MAP['bottom'].includes(type);
        }

        // 判断商品类型是上衣还是下装
        isTopOrBottom(type) {
            if (TYPE_MAP['top'].includes(type)) {
                return 'topUserSize';
            } else if (TYPE_MAP['bottom'].includes(type)) {
                return 'bottomUserSize';
            } else {
                console.warn(`未知的商品类型: ${type}`);
                return null;
            }
        }

        initSizeClickListener() {
            $(document).on('click', '.js-remake_li', () => {
                console.log('尺码被点击，重新初始化按钮');
                // 移除旧按钮
                const oldButton = document.querySelector('.size-finder-btn');
                if (oldButton) {
                    oldButton.remove();
                }
                // 重新挂载按钮
                this.mount(this.config.mTarget);
            });
        }

        initUnitToggle(step1) {
            const heightUnitBtns = step1.querySelectorAll('.height-group .unit-btn');
            const weightUnitBtns = step1.querySelectorAll('.weight-group .unit-btn');
            const nextStepButton = step1.querySelector('.next-step');

            const checkInputs = () => {
                const heightCm = step1.querySelector('input[name="height-cm"]').value;
                const heightFt = step1.querySelector('input[name="height-ft"]').value;
                const heightIn = step1.querySelector('input[name="height-in"]').value;
                const weightKg = step1.querySelector('input[name="weight-kg"]').value;
                const weightLbs = step1.querySelector('input[name="weight-lbs"]').value;

                // 检查所有输入框是否有值
                if ((heightCm != 0 || (heightFt && heightIn)) && (weightKg != 0 || weightLbs)) {
                    nextStepButton.classList.remove('disabled'); // 启用按钮
                } else {
                    nextStepButton.classList.add('disabled'); // 禁用按钮
                }
            };

            // 单位转换函数
            const convertUnits = {
                ftInToCm: (ft, inch) => {
                    if (!ft && !inch) return '';
                    ft = parseFloat(ft) || 0;
                    inch = parseFloat(inch) || 0;
                    const totalInches = (ft * 12) + inch;
                    return Math.round(totalInches * 2.54);
                },
                cmToFtIn: (cm) => {
                    if (!cm) return { ft: '', in: '' };
                    const totalInches = cm / 2.54;
                    const ft = Math.floor(totalInches / 12);
                    const inch = Math.round(totalInches % 12);
                    return { ft, in: inch };
                },
                lbsToKg: (lbs) => {
                    if (!lbs) return '';
                    return Math.round(lbs / 2.2046);
                },
                kgToLbs: (kg) => {
                    if (!kg) return '';
                    return Math.round(kg * 2.2046);
                }
            };

            const handleUnitChange = (clickedBtn, isHeightUnit) => {
                const unit = clickedBtn.dataset.unit;

                // 移除当前组所有按钮的 active 状态并设置新的 active
                if (isHeightUnit) {
                    heightUnitBtns.forEach(btn => btn.classList.remove('active'));
                    clickedBtn.classList.add('active');
                    // 同步体重按钮状态
                    weightUnitBtns.forEach(btn => {
                        btn.classList.remove('active');
                        if ((unit === 'inch' && btn.dataset.unit === 'lbs') ||
                            (unit === 'cm' && btn.dataset.unit === 'kg')) {
                            btn.classList.add('active');
                        }
                    });
                } else {
                    weightUnitBtns.forEach(btn => btn.classList.remove('active'));
                    clickedBtn.classList.add('active');
                    // 同步身高按钮状态
                    heightUnitBtns.forEach(btn => {
                        btn.classList.remove('active');
                        if ((unit === 'lbs' && btn.dataset.unit === 'inch') ||
                            (unit === 'kg' && btn.dataset.unit === 'cm')) {
                            btn.classList.add('active');
                        }
                    });
                }

                // 获取所有输入框
                const ftInput = step1.querySelector('input[name="height-ft"]');
                const inInput = step1.querySelector('input[name="height-in"]');
                const cmInput = step1.querySelector('input[name="height-cm"]');
                const lbsInput = step1.querySelector('input[name="weight-lbs"]');
                const kgInput = step1.querySelector('input[name="weight-kg"]');

                // 添加输入框值变化监听
                const handleHeightInputChange = () => {
                    if (ftInput.value === '' && inInput.value === '') {
                        cmInput.value = '';
                    } else {
                        cmInput.value = convertUnits.ftInToCm(ftInput.value, inInput.value);
                    }
                    checkInputs()
                };

                const handleCmInputChange = () => {
                    if (cmInput.value === '') {
                        ftInput.value = '';
                        inInput.value = '';
                    } else {
                        const { ft, in: inches } = convertUnits.cmToFtIn(cmInput.value);
                        ftInput.value = ft;
                        inInput.value = inches;
                    }
                    checkInputs()

                };

                const handleWeightInputChange = () => {
                    if (lbsInput.value === '') {
                        kgInput.value = '';
                    } else {
                        kgInput.value = convertUnits.lbsToKg(lbsInput.value);
                    }
                    checkInputs()

                };

                const handleKgInputChange = () => {
                    if (kgInput.value === '') {
                        lbsInput.value = '';
                    } else {
                        lbsInput.value = convertUnits.kgToLbs(kgInput.value);
                    }
                    checkInputs()

                };

                // 绑定输入框变化事件
                ftInput.addEventListener('input', handleHeightInputChange);
                inInput.addEventListener('input', handleHeightInputChange);
                cmInput.addEventListener('input', handleCmInputChange);
                lbsInput.addEventListener('input', handleWeightInputChange);
                kgInput.addEventListener('input', handleKgInputChange);

                // 根据点击的单位类型转换所有值
                // 根据点击的单位类型转换所有值
                if (unit === 'cm' || unit === 'kg') {
                    // 转换身高到公制
                    if (!ftInput.value && !inInput.value) {
                        cmInput.value = '';
                    } else {
                        cmInput.value = convertUnits.ftInToCm(ftInput.value, inInput.value);
                    }
                    // 转换体重到公制
                    if (!lbsInput.value) {
                        kgInput.value = '';
                    } else {
                        kgInput.value = convertUnits.lbsToKg(lbsInput.value);
                    }
                    // 显示公制输入框
                    step1.querySelector('.inch-inputs').style.display = 'none';
                    step1.querySelector('.cm-inputs').style.display = 'flex';
                    step1.querySelector('.lbs-inputs').style.display = 'none';
                    step1.querySelector('.kg-inputs').style.display = 'flex';
                } else {
                    // 转换身高到英制
                    if (!cmInput.value) {
                        ftInput.value = '';
                        inInput.value = '';
                    } else {
                        const { ft, in: inches } = convertUnits.cmToFtIn(cmInput.value);
                        ftInput.value = ft;
                        inInput.value = inches;
                    }
                    // 转换体重到英制
                    if (!kgInput.value) {
                        lbsInput.value = '';
                    } else {
                        lbsInput.value = convertUnits.kgToLbs(kgInput.value);
                    }
                    // 显示英制输入框
                    step1.querySelector('.inch-inputs').style.display = 'flex';
                    step1.querySelector('.cm-inputs').style.display = 'none';
                    step1.querySelector('.lbs-inputs').style.display = 'flex';
                    step1.querySelector('.kg-inputs').style.display = 'none';
                }

                checkInputs();
            };

            // 绑定身高单位切换事件
            heightUnitBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    handleUnitChange(e.target, true);
                });
            });

            // 绑定体重单位切换事件
            weightUnitBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    handleUnitChange(e.target, false);
                });
            });


            return convertUnits; // 返回转换函数对象
        }


        // 创建按钮并插入指定位置
        mount(selector) {
            const targetElement = document.querySelector(selector);
            if (!targetElement) {
                console.error(`找不到目标元素: ${selector}`);
                return;
            }

            const button = this.createButton();
            targetElement.appendChild(button);
        }

        // 创建按钮元素
        createButton() {
            const button = document.createElement('div');
            button.className = 'size-finder-btn';
            if (this.savedSize && ((!this.recommendedSize || this.recommendedSize == '/'))) {
                button.textContent = 'My Size: /'
                document.querySelectorAll('.size-finder-btn').forEach(item => {
                    item.textContent = 'My Size: /'
                })
            } else if (this.savedSize && this.recommendedSize) {
                button.textContent = `My Size: ${this.recommendedSize}`;
                document.querySelectorAll('.size-finder-btn').forEach(item => {
                    item.textContent = `My Size: ${this.recommendedSize}`;
                })
            } else {
                button.textContent = this.config.buttonText;
                document.querySelectorAll('.size-finder-btn').forEach(item => {
                    item.textContent = this.config.buttonText;
                })
            }

            button.addEventListener('click', () => this.showModal());
            return button;
        }


        // 显示弹窗
        showModal() {
            console.log('showModal');
            const modal = this.createModal();
            document.body.appendChild(modal.overlay);
            document.body.appendChild(modal.container);
        }

        // 创建弹窗内容
        createModal() {
            const overlay = document.createElement('div');
            overlay.className = 'size-finder-overlay';

            const container = document.createElement('div');
            container.className = 'size-finder-modal';

            // 检测是否为移动设备
            const isMobile = window.innerWidth <= 768;
            if (isMobile) {
                container.classList.add('size-finder-modal-mobile');
            }

            // 创建表单内容
            const form = this.createForm();
            container.appendChild(form);


            // 如果是移动设备，添加动画延迟
            if (isMobile) {
                setTimeout(() => {
                    container.classList.add('size-finder-modal-mobile-active');
                }, 10);
            }

            return { overlay, container };
        }


        createStep1() {
            const step1 = document.createElement('div');
            step1.className = 'size-finder-step step1';
            step1.innerHTML = `
                    <div class="form-group height-group">
                        <div class="label-with-units">
                            <label>Height</label>
                            <div class="unit-toggle">
                                <div class="unit-btn active" data-unit="inch">inch</div>
                                <div class="unit-btn" data-unit="cm">cm</div>
                            </div>
                        </div>

                        <div class="height-inputs inch-inputs">
                            <div class="input-with-unit">
                                <input type="number" name="height-ft" maxlength="1"  oninput="this.value = this.value.slice(0, 1);">
                                <span class="unit-label">ft</span>
                            </div>
                            <div class="input-with-unit">
                                <input type="number" name="height-in" oninput="this.value = this.value.slice(0, 2);"  maxlength="2">
                                <span class="unit-label">in</span>
                            </div>
                            <div class="error-tip height-error">Please enter your height between 2’11‘’ and 8'7''</div>
                        </div>

                        <div class="height-inputs cm-inputs" style="display: none;">
                            <div class="input-with-unit">
                                <input type="number" name="height-cm" oninput="this.value = this.value.slice(0, 3);"  maxlength="3">
                                <span class="unit-label">cm</span>
                            </div>
                            <div class="error-tip height-error">Please enter your height between 89 and 262 cm</div>
                        </div>
                    </div>

                    <!-- 体重部分 -->
                    <div class="form-group weight-group">
                        <div class="label-with-units">
                            <label>Weight</label>
                            <div class="unit-toggle">
                                <div class="unit-btn active" data-unit="lbs">lbs</div>
                                <div class="unit-btn" data-unit="kg">kg</div>
                            </div>
                        </div>

                        <div class="weight-inputs lbs-inputs">
                            <div class="input-with-unit">
                                <input type="number" name="weight-lbs" oninput="this.value = this.value.slice(0, 3);"  maxlength="3">
                                <span class="unit-label">lbs</span>
                            </div>
                            <div class="error-tip weight-error">Please enter your weight between 55 and 441 lbs</div>
                        </div>

                        <div class="weight-inputs kg-inputs" style="display: none;">
                            <div class="input-with-unit">
                                <input type="number" name="weight-kg" oninput="this.value = this.value.slice(0, 3);"  maxlength="3">
                                <span class="unit-label">kg</span>
                            </div>
                            <div class="error-tip weight-error">Please enter your weight between 25 and 200 kg</div>
                        </div>
                    </div>

                    <div class="bottom-text-container">
                        <div class="bottom-text">
                            By clicking below you consent to the use of your personal information so we may recommend the best size for you.
                            For more information, please refer to our
                            <a href="https://urbanrevivo.com/pages/privacy-policy">
                                Privacy Policy
                            </a>
                        </div>
                        <div class="next-step">FIND MY SIZE</div>
                    </div>
                    </div>
            `;
            return step1;
        }

        createStep2() {
            const step2 = document.createElement('div');
            step2.className = 'size-finder-step step2';
            step2.innerHTML = `
                <div class="step2-size-detail-container">
                    <div class="size-btn-wrap">
                        <div class="step2-title">
                            My Information
                        </div>

                        <div class="step2-info-wrap">
                            <div class="step2-size-detail-inch" style="display: none;">
                                <div class="step2-size-detail-height">
                                    Height: <span class="step2-size-detail-height-value">170cm</span>
                                </div>
                                <div class="step2-size-detail-weight">
                                    Weight: <span class="step2-size-detail-weight-value">50kg</span>
                                </div>
                            </div>

                            <div class="step2-size-detail-cm" style="display: none;">
                                <div class="step2-size-detail-height">
                                    Height: <span class="step2-size-detail-height-value">66.93in</span>
                                </div>
                                <div class="step2-size-detail-weight">
                                    Weight: <span class="step2-size-detail-weight-value">110.23lbs</span>
                                </div>
                            </div>

                            <div class="step2-handle-btn">
                                <div class="reset-size">Edit</div>
                                <div class="step2-size-detail-delete">Delete</div>
                            </div>
                        </div>
                    </div>

                    <div class="cut-line"></div>

                    <div class="step2-size-detail-recommend">
                        <div class="step2-size-detail-recommend-title">
                            Size Recommendation
                        </div>
                        <div class="step2-size-detail-recommend-image">
                            
                            <img src="" id="current-image" alt="Size Recommendation">
                        </div>
                        <div class="step2-size-recommend-desc mo">
                            <div class="step2-have-size" style="display: none;">
                                <div class="step2-size-recommend-desc-title">My Size Is:</div>
                                <div class="step2-size-recommend-desc-size"></div>
                            </div>
                            <div class="step2-no-size" style="display: none;">
                                No recommendations for now.
                            </div>
                        </div>
                        <div class="step2-size-recommend-desc-tip mo">
                            For more precise sizing,please refer to the size chart.
                        </div>
                    </div>
                    <div class="step2-bottom-container">
                        <div class="step2-size-recommend-desc pc">
                            <div class="step2-have-size" style="display: none;">
                                <div class="step2-size-recommend-desc-title">My Size Is:</div>
                                <div class="step2-size-recommend-desc-size"></div>
                            </div>
                            <div class="step2-no-size" style="display: none;">
                                No recommendations for now.
                            </div>
                        </div>
                        <div class="step2-size-recommend-desc-tip pc">
                            For more precise sizing,please refer to the size chart.
                        </div>
                        
                        <div class="step2-close">CLOSE</div>
                    </div>
                </div>
            `;
            return step2;
        }

        closeModule(btn) {
            btn.onclick = () => {
                const modal = document.querySelector('.size-finder-modal');
                const overlay = document.querySelector('.size-finder-overlay');

                // 检查是否是移动设备
                const isMobile = window.innerWidth <= 768;

                if (isMobile) {
                    // 移动端添加关闭动画
                    modal.classList.remove('size-finder-modal-mobile-active');
                    setTimeout(() => {
                        if (modal && overlay) {
                            document.body.removeChild(modal);
                            document.body.removeChild(overlay);
                        }
                    }, 300); // 等待动画完成
                } else {
                    // PC端直接关闭
                    if (modal && overlay) {
                        document.body.removeChild(modal);
                        document.body.removeChild(overlay);
                    }
                }
            };
        }
        // 创建表单
        createForm() {
            const position = this.isTopOrBottom(this.config.productType);
            this.savedSize = this.getCookie('userSize');
            const form = document.createElement('form');
            form.className = 'size-finder-form';

            // 头部
            const header = document.createElement('div');
            header.className = 'form-header';
            header.innerHTML = `
                <h2>My Information</h2>
                <div class="close-btn size-finder-close full-close-btn"></div>
            `;

            // 绑定关闭按钮事件
            const closeBtn = header.querySelector('.size-finder-close');
            this.closeModule(closeBtn)

            form.appendChild(header);
            // 第一步：身高体重填写表单
            const step1 = this.createStep1();
            // 第二步：尺码推荐展示
            const step2 = this.createStep2();
            const convertUnits = this.initUnitToggle(step1);
            const step2CloseBtn = step2.querySelector('.step2-close');
            this.closeModule(step2CloseBtn)



            form.appendChild(step1);
            form.appendChild(step2);
            const nextStepButton = step1.querySelector('.next-step');
            nextStepButton.classList.add('disabled'); // 初始禁用按钮
            // 根据是否有存储的数据决定显示哪一步
            if (this.savedSize) {
                nextStepButton.classList.remove('disabled'); // 初始禁用按钮
                const savedUnits = this.savedSize.units || { height: 'cm', weight: 'kg' };


                // 如果有存储的数据，直接显示第二步
                step2.classList.add('active');
                step2.querySelector('#current-image').setAttribute('src', this.getCurrentImage())

                const inchDetail = step2.querySelector('.step2-size-detail-inch');
                const cmDetail = step2.querySelector('.step2-size-detail-cm');
                
                if (savedUnits.height === 'inch') {
                    inchDetail.style.display = 'flex';
                    cmDetail.style.display = 'none';
                    // 设置英制值
                    const { ft, in: inches } = convertUnits.cmToFtIn(this.savedSize.height);
                    const lbs = convertUnits.kgToLbs(this.savedSize.weight);
                    inchDetail.querySelector('.step2-size-detail-height-value').innerHTML =
                    `<strong>${ft}</strong> ft <strong>${inches}</strong> in`;
                 inchDetail.querySelector('.step2-size-detail-weight-value').innerHTML =
                     `<strong>${lbs}</strong> lbs`;
                } else {
                    inchDetail.style.display = 'none';
                    cmDetail.style.display = 'flex';
                    // 设置公制值
                    cmDetail.querySelector('.step2-size-detail-height-value').innerHTML =
                        `<strong>${this.savedSize.height}</strong> cm`;
                    cmDetail.querySelector('.step2-size-detail-weight-value').innerHTML =
                        `<strong>${this.savedSize.weight}</strong> kg`;
                }

                // const sizeResult = step2.querySelector('.step2-size-recommend-desc-size');
                // sizeResult.textContent = this.recommendedSize;
                step2.querySelectorAll('.step2-size-recommend-desc-size').forEach(item => {
                    item.textContent = this.recommendedSize;
                })

                header.querySelector('h2').style.display = 'none'
                header.classList.add('step2-reset')

                if (this.recommendedSize !== '/' && this.recommendedSize !== null) {
                    // step2.querySelector('.step2-have-size').style.display = 'block';

                    step2.querySelectorAll('.step2-have-size').forEach(item => {
                        item.style.display = 'block';
                    })
                    step2.querySelectorAll('.step2-none-size').forEach(item => {
                        item.style.display = 'none';
                    })
                } else {
                    // step2.querySelector('.step2-no-size').style.display = 'block';
                    step2.querySelectorAll('.step2-no-size').forEach(item => {
                        item.style.display = 'block';
                    })
                    step2.querySelectorAll('.step2-have-size').forEach(item => {
                        item.style.display = 'none';
                    })
                }
                // 切换显示步骤

                // 设置单位按钮状态
                const heightBtns = step1.querySelectorAll('.height-group .unit-btn');
                const weightBtns = step1.querySelectorAll('.weight-group .unit-btn');

                heightBtns.forEach(btn => {
                    if (btn.dataset.unit === savedUnits.height) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });

                weightBtns.forEach(btn => {
                    if (btn.dataset.unit === savedUnits.weight) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });

                // 根据保存的单位显示对应的输入框
                if (savedUnits.height === 'inch') {
                    step1.querySelector('.inch-inputs').style.display = 'flex';
                    step1.querySelector('.cm-inputs').style.display = 'none';
                    // 设置英制身高值
                    const { ft, in: inches } = convertUnits.cmToFtIn(this.savedSize.height);
                    step1.querySelector('input[name="height-ft"]').value = ft;
                    step1.querySelector('input[name="height-in"]').value = inches;
                } else {
                    step1.querySelector('.inch-inputs').style.display = 'none';
                    step1.querySelector('.cm-inputs').style.display = 'flex';
                    // 设置公制身高值
                    step1.querySelector('input[name="height-cm"]').value = this.savedSize.height;
                }

                if (savedUnits.weight === 'lbs') {
                    step1.querySelector('.lbs-inputs').style.display = 'flex';
                    step1.querySelector('.kg-inputs').style.display = 'none';
                    // 设置英制体重值
                    step1.querySelector('input[name="weight-lbs"]').value = convertUnits.kgToLbs(this.savedSize.weight);
                } else {
                    step1.querySelector('.lbs-inputs').style.display = 'none';
                    step1.querySelector('.kg-inputs').style.display = 'flex';
                    // 设置公制体重值
                    step1.querySelector('input[name="weight-kg"]').value = this.savedSize.weight;
                }
            } else {
                // 如果没有存储的数据，显示第一步
                step1.classList.add('active');
            }



            const checkInputs = () => {
                const heightCm = step1.querySelector('input[name="height-cm"]').value;
                const heightFt = step1.querySelector('input[name="height-ft"]').value;
                const heightIn = step1.querySelector('input[name="height-in"]').value;
                const weightKg = step1.querySelector('input[name="weight-kg"]').value;
                const weightLbs = step1.querySelector('input[name="weight-lbs"]').value;

                // 检查所有输入框是否有值
                if ((heightCm != 0 || (heightFt && heightIn)) && (weightKg != 0 || weightLbs)) {
                    nextStepButton.classList.remove('disabled'); // 启用按钮
                } else {
                    nextStepButton.classList.add('disabled'); // 禁用按钮
                }
            };

            const validationInputs = () => {
                console.log('.validationInputs')
                let flag = true;
                // 获取输入值
                const heightValue = step1.querySelector('input[name="height-cm"]').value ||
                    convertUnits.ftInToCm(
                        step1.querySelector('input[name="height-ft"]').value,
                        step1.querySelector('input[name="height-in"]').value
                    );

                const weightValue = step1.querySelector('input[name="weight-kg"]').value ||
                    convertUnits.lbsToKg(step1.querySelector('input[name="weight-lbs"]').value);

                if (!heightValue || !weightValue) {
                    flag = false;
                    nextStepButton.classList.add('disabled');
                } else {
                    if (heightValue < 89 || heightValue > 262) {
                        flag = false;
                        step1.querySelectorAll('.height-error').forEach(item => {
                            item.style.display = 'block';
                        })
                    } else {
                        step1.querySelectorAll('.height-error').forEach(item => {
                            item.style.display = 'none';
                        })
                    }
                    if (weightValue < 25 || weightValue > 200) {
                        flag = false;
                        step1.querySelectorAll('.weight-error').forEach(item => {
                            item.style.display = 'block';
                        })
                    } else {
                        step1.querySelectorAll('.weight-error').forEach(item => {
                            item.style.display = 'none';
                        })
                    }
                }
                return flag
            }

            // 绑定输入框的 input 事件
            step1.querySelectorAll('input').forEach(input => {
                input.addEventListener('input', checkInputs);
            });
            step1.querySelectorAll('input').forEach(input => {
                input.addEventListener('blur', validationInputs);
            });

            nextStepButton.onclick = () => {

                const heightValue = step1.querySelector('input[name="height-cm"]').value ||
                    convertUnits.ftInToCm(
                        step1.querySelector('input[name="height-ft"]').value,
                        step1.querySelector('input[name="height-in"]').value
                    );

                const weightValue = step1.querySelector('input[name="weight-kg"]').value ||
                    convertUnits.lbsToKg(step1.querySelector('input[name="weight-lbs"]').value);

                let flag = validationInputs();


                if (!flag) {
                    return;
                }

                document.querySelectorAll('.error-tip').forEach(item => {
                    item.style.display = 'none'
                })

                step2.querySelector('#current-image').setAttribute('src', this.getCurrentImage())

                try {
                    const activeHeightUnit = step1.querySelector('.height-group .unit-btn.active').dataset.unit;

                    // 保存数据时包含单位信息
                    const data = {
                        height: heightValue,
                        weight: weightValue,
                        units: {
                            height: activeHeightUnit,
                            weight: activeHeightUnit === 'inch' ? 'lbs' : 'kg'
                        }
                    };
                    // 保存数据并计算推荐尺码
                    this.saveSizeData(data);
                    this.recommendedSize = this.calculateRecommendedSize(data);

                    this.savedSize = data;

                    step1.classList.remove('active');
                    step2.classList.add('active');
                    header.querySelector('h2').style.display = 'none'

                    header.classList.add('step2-reset')
                    // 根据当前单位显示对应的度量值区域
                    const inchDetail = step2.querySelector('.step2-size-detail-inch');
                    const cmDetail = step2.querySelector('.step2-size-detail-cm');

                    if (activeHeightUnit === 'inch') {
                        inchDetail.style.display = 'flex';
                        cmDetail.style.display = 'none';
                        // 设置英制值
                        const { ft, in: inches } = convertUnits.cmToFtIn(heightValue);
                        const lbs = convertUnits.kgToLbs(weightValue);
                        inchDetail.querySelector('.step2-size-detail-height-value').innerHTML =
                           `<strong>${ft}</strong> ft <strong>${inches}</strong> in`;
                        inchDetail.querySelector('.step2-size-detail-weight-value').innerHTML =
                            `<strong>${lbs}</strong> lbs`;
                    } else {
                        inchDetail.style.display = 'none';
                        cmDetail.style.display = 'flex';
                        // 设置公制值
                        cmDetail.querySelector('.step2-size-detail-height-value').innerHTML =
                            `<strong>${heightValue}</strong> cm`;
                        cmDetail.querySelector('.step2-size-detail-weight-value').innerHTML =
                            `<strong>${weightValue}</strong> kg`;
                    }
                    if (this.recommendedSize && this.recommendedSize !== '/') {
                        // 更新第二步的内容
                        // const sizeResult = step2.querySelector('.step2-size-recommend-desc-size');
                        // const sizeDescription = step2.querySelector('.size-description');
                        // sizeResult.textContent = this.recommendedSize;

                        step2.querySelectorAll('.step2-size-recommend-desc-size').forEach(item => {
                            item.textContent = this.recommendedSize;
                        })

                        // step2.querySelector('.step2-have-size').style.display = 'block';
                        // step2.querySelector('.step2-no-size').style.display = 'none';

                        step2.querySelectorAll('.step2-have-size').forEach(item => {
                            item.style.display = 'block';
                        })
                        step2.querySelectorAll('.step2-no-size').forEach(item => {
                            item.style.display = 'none';
                        })


                        this.setDefaultSize()

                        document.querySelectorAll('.size-finder-btn').forEach(item => {
                            item.textContent = 'My Size:' + this.recommendedSize
                        })


                        // 切换显示步骤

                    } else {

                        step2.querySelectorAll('.step2-no-size').forEach(item => {
                            item.style.display = 'block';
                        })
                        step2.querySelectorAll('.step2-have-size').forEach(item => {
                            item.style.display = 'none';
                        })
                        document.querySelectorAll('#current-is-recommend').forEach(item => {
                            item.style.display = 'none';
                        })
                        document.querySelectorAll('.recommended-text').forEach(item => {
                            item.style.display = 'none';
                        })
                        document.querySelectorAll('.size-finder-btn').forEach(item => {
                            item.textContent = 'My Size: /'
                        })
                        
                    }
                } catch (error) {
                    console.error('获取尺码失败:', error);
                    // alert('获取尺码失败，请重试');
                }
            };

            // 重新填写按钮点击事件
            const resetButton = step2.querySelector('.reset-size');
            resetButton.onclick = () => {
                step2.classList.remove('active');
                step1.classList.add('active');
                header.querySelector('h2').style.display = 'block'
                header.classList.remove('step2-reset')
            };

            const deleteButton = step2.querySelector('.step2-size-detail-delete');
            deleteButton.onclick = () => {
                this.deleteCookie('userSize')
                $('#current-is-recommend, .recommended-text').hide()
                // this.deleteCookie('bottomUserSize')
                step1.querySelector('input[name="height-cm"]').value = '';
                step1.querySelector('input[name="height-ft"]').value = '';
                step1.querySelector('input[name="height-in"]').value = '';
                step1.querySelector('input[name="weight-kg"]').value = '';
                step1.querySelector('input[name="weight-lbs"]').value = '';

                // 禁用 "Find My Size" 按钮
                const nextStepButton = step1.querySelector('.next-step');
                nextStepButton.classList.add('disabled'); // 禁用按钮
                step2.classList.remove('active');
                step1.classList.add('active');
                header.querySelector('h2').style.display = 'block'
                header.classList.remove('step2-reset')
                document.querySelectorAll('.size-finder-btn').forEach(item => {
                    item.textContent = 'Find My Size'
                })
            }

            return form;
        }


        calculateRecommendedSize(data) {
            const currentSize = $('.current-select .nt_name_current').text();
            const isSize = currentSize - 0 == currentSize ? true : false;
            const lastSize = $(`.js-remake_li:last`).data('escape');
            const height = parseInt(data.height);
            const weight = parseInt(data.weight);

            // 确定身高范围
            let heightRange = null;
            if (height >= 150 && height <= 155) heightRange = '150-155';
            else if (height >= 155 && height <= 160) heightRange = '155-160';
            else if (height >= 160 && height <= 165) heightRange = '160-165';
            else if (height >= 165 && height <= 170) heightRange = '165-170';
            else if (height >= 170 && height <= 175) heightRange = '170-175';
            else if (height >= 175 && height <= 180) heightRange = '175-180';
            else if (height >= 180 && height <= 185) heightRange = '180-185';

            if (!heightRange) return null;

            // 确定体重范围
            const weightRanges = this.isTopOrBottom(this.config.productType) === 'topUserSize'
                ? Object.keys(SIZE_TOP_MAP[heightRange])
                : Object.keys(SIZE_BOTTOM_MAP[heightRange]);

            let recommendedSizes = []; // 存储所有推荐尺码
            let maxSizeObj = [];

            for (let range of weightRanges) {
                const [min, max] = range.split('-').map(Number);
                if (weight >= min && weight <= max) {
                    const size = this.isTopOrBottom(this.config.productType) === 'topUserSize'
                        ? SIZE_TOP_MAP[heightRange][range]
                        : SIZE_BOTTOM_MAP[heightRange][range];
                    recommendedSizes.push(size); // 添加到推荐尺码列表
                    maxSizeObj.push({ size, weightRange: range })
                }
            }

            // 选择最大的尺码
            if (recommendedSizes.length > 0) {
                // const maxSize = this.getMaxSize(recommendedSizes);
                const { maxSize, maxIndex } = this.getMaxSize(recommendedSizes);
                const maxSizeInfo = maxSizeObj[maxIndex]
                console.log('maxIndex:', maxIndex)
                console.log('maxSizeObj:', maxSizeObj)
                console.log('maxSizeInfo:', maxSizeInfo)
                console.log('当前尺码是：', maxSize);
                console.log('系列编码：', this.config.productTags[0]);

                // 检查计算出的尺码是否大于 lastSize
                if (this.isSizeGreater(maxSize, lastSize)) {
                    console.log('计算出的尺码大于最大尺码，返回 null');
                    return null; // 如果计算出的尺码大于最大尺码，则返回 null
                }
                // // 兼容匹配大一码的逻辑
                // if (recommendedSizes.length > 0 && this.config.productTags && this.config.productTags[0] != 'I') {
                //     console.log('需要加大一码')
                //     const nextSize = this.getNextSize(maxSize, this.isTopOrBottom(this.config.productType) === 'topUserSize' ? SIZE_TOP_MAP[heightRange] : SIZE_BOTTOM_MAP[heightRange], weight);

                //     console.log('加大一码是：', nextSize)
                //     return nextSize || maxSize; // 如果没有下一个尺码，则返回最大尺码
                // }

                // 兼容匹配大一码的逻辑
                if (recommendedSizes.length > 0 && this.config.productTags && this.config.productTags[0] != 'I') {
                    console.log('需要加大一码');
                    let nextSize = this.getNextSize(maxSizeInfo, this.isTopOrBottom(this.config.productType) === 'topUserSize' ? SIZE_TOP_MAP[heightRange] : SIZE_BOTTOM_MAP[heightRange], weight);
                    // 检查加大后的尺码是否大于当前尺码
                    if (this.isSizeGreater(nextSize, lastSize) || nextSize == '/') {
                        console.log('加大一码后大于当前尺码，返回 null:', nextSize);
                        return null; // 如果加大后的尺码大于当前尺码，则返回 null
                    }
                    nextSize = isSize ? nextSize.split('/')[1] : nextSize.split('/')[0]
                    console.log('加大一码是：', nextSize);
                    return nextSize || maxSize; // 如果没有下一个尺码，则返回最大尺码
                }

                return isSize ? maxSize.split('/')[1] : maxSize;
            }

            return null;
        }

        isSizeGreater(size1, size2) {
            const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL']; // 尺码顺序
        
            // 获取 size1 的索引
            const index1 = this.getSizeIndex(size1, sizeOrder);
        
            // 获取 size2 的索引
            const index2 = this.getSizeIndex(size2, sizeOrder);
        
            return index1 > index2; // 返回比较结果
        }
        
        // 辅助函数：获取尺码的索引
        getSizeIndex(size, sizeOrder) {
            if (typeof size === 'string') {
                if (size.includes('/')) {
                    // 处理英文/数字尺码，比如 M/25
                    return sizeOrder.indexOf(size.split('/')[0]) !== -1 
                        ? sizeOrder.indexOf(size.split('/')[0]) 
                        : Number(size.split('/')[1]); // 返回数字部分
                } else {
                    // 处理单一英文字码，比如 M
                    return sizeOrder.indexOf(size) !== -1 
                        ? sizeOrder.indexOf(size) 
                        : Number(size); // 如果不在尺码顺序中，尝试转换为数字
                }
            } else if (typeof size === 'number') {
                // 处理数字尺码
                return Number(size);
            }
            return -1; // 如果不匹配，返回 -1
        }

        // 获取最大尺码
        getMaxSize(sizes) {
            const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL']; // 尺码顺序
            let maxSize = sizes[0]; // 初始化最大尺码
            let maxIndex = 0; // 初始化最大尺码的下标

            sizes.forEach((size, index) => {
                const currentIndex = sizeOrder.indexOf(size.split('/')[0]); // 获取当前尺码的索引
                const maxIndexCurrent = sizeOrder.indexOf(maxSize.split('/')[0]); // 获取最大尺码的索引
                if (currentIndex > maxIndexCurrent) {
                    maxSize = size; // 更新最大尺码
                    maxIndex = index; // 更新最大尺码的下标
                }
            });

            return { maxSize, maxIndex }; // 返回最大尺码和其下标
        }
        // 获取下一个尺码的辅助函数

        getNextSize(maxSizeObj, sizeMap, currentWeight) {
            const sizes = Object.entries(sizeMap); // 获取尺码范围及其对应的尺码
            let foundCurrent = false; // 标记是否找到当前尺码
            let nextSize = null; // 存储下一个尺码

            // 首先根据当前体重找到所有匹配的尺码
            for (const [range, size] of sizes) {
                const [min, max] = range.split('-').map(Number); // 解析体重范围

                // 检查当前尺码是否匹配
                if (size === maxSizeObj.size) {
                    foundCurrent = true; // 找到当前尺码
                }

                // 检查当前体重是否在范围内
                if (currentWeight >= min && currentWeight <= max) {
                    // 如果已经找到当前尺码，返回下一个尺码
                    if (foundCurrent) {
                        nextSize = size; // 获取下一个尺码
                        break; // 找到下一个尺码后退出循环
                    }
                }
            }

            // 如果找到了当前尺码，尝试获取下一个尺码
            if (foundCurrent) {
                const currentIndex = sizes.findIndex(([range]) => range.includes(maxSizeObj.weightRange)); // 根据体重范围找到当前尺码的索引
                // 查找下一个尺码
                if (currentIndex + 1 < sizes.length) {
                    nextSize = sizes[currentIndex + 1][1]; // 获取下一个尺码
                }
            }

            return nextSize || null; // 返回下一个尺码或 null
        }

        setDefaultSize() {
            if (!$('.js-remake_li.is-selected').length) {
                setTimeout(() => {
                    this.setDefaultSize()
                }, 100)
                return false
            }
            if (!this.recommendedSize || this.recommendedSize == '/') {
                return false
            }
            const currentSize = $('.current-select .nt_name_current').text();
            const isSize = currentSize - 0 == currentSize ? true : false;
            const isSlash = this.recommendedSize.indexOf('/') > - 1
            let setSize = '';

            if (isSlash && isSize) {
                setSize = this.recommendedSize.split('/')[1]
            } else if (isSlash && !isSize) {
                setSize = this.recommendedSize.split('/')[0]
            } else {
                setSize = this.recommendedSize
            }

            document.querySelectorAll('.recommended-text').forEach(item => {
                item.style.display = 'none';
            })

            const currentSetSize = $(`.js-remake_li[data-escape=${setSize}]`)
            if (currentSetSize.length > 0 && !currentSetSize.hasClass('nt_soldout')) {
                currentSetSize.trigger('click');
            }
            $(`.js-remake_li[data-escape=${setSize}]`).find('.recommended-text').show()
            currentSetSize == this.recommendedSize ? $('#current-is-recommend').show() : ''

        }


        watchCurrentSize() {
            const _this = this
            $('.theiaStickySidebar .js-remake-size').on('click', '.swatch_pr_item', function () {
                console.log('js-remake_li click')
                const currentSize = $(this).data('escape')
                if (currentSize != _this.recommendedSize) {
                    $('#current-is-recommend').hide()
                } else {
                    $('#current-is-recommend').show()
                }
            })
        }

        getCurrentImage() {
            let url = $('.is-color .swatch_pr_item.is-selected ').find('.swatch__value_pr').css('backgroundImage');
            const regex = /url\("?(https?:\/\/[^"()]+)"?\)/;

            // 使用正则表达式进行匹配
            const match = url.match(regex);

            if (match && match[1]) {
                console.log(match[1]); // 输出提取的 URL
                return match[1]
            } else {
                console.log('未找到 URL');
            }

        }
        addToCart(productId) { }


        // Cookie 操作
        setCookie(name, value, days) {
            const expires = new Date();
            expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
        }

        getCookie(name) {
            const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
            return match ? JSON.parse(decodeURIComponent(match[2])) : null;
        }

        saveSizeData(data) {
            const position = this.isTopOrBottom(this.config.productType);
            // 获取当前激活的单位
            const activeHeightUnit = document.querySelector('.height-group .unit-btn.active').dataset.unit;
            const activeWeightUnit = document.querySelector('.weight-group .unit-btn.active').dataset.unit;

            // 保存数据时包含单位信息
            const saveData = {
                ...data,
                units: {
                    height: activeHeightUnit,
                    weight: activeWeightUnit
                }
            };

            this.setCookie('userSize', JSON.stringify(saveData), this.config.cookieExpireDays);
        }

        deleteCookie(name) {
            this.setCookie(name, '', -1);
        }

    }

    return SizeFinder;
}));